import React from "react";
import { Col, Row, Select, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowIcon } from "@/assets/icons/arrow.svg";
import { ReactComponent as RebackIcon } from "@/assets/icons/reback.svg";
import { ReactComponent as ForwardIcon } from "@/assets/icons/forwark.svg";
import { ReactComponent as ZoomOutIcon } from "@/assets/icons/zoom-out.svg";
import { ReactComponent as ZoomInIcon } from "@/assets/icons/zoom-in.svg";
import { ReactComponent as RebackPageIcon } from "@/assets/icons/reback-page-btn.svg";
import "@/assets/imageCutout.less";

const { Option } = Select;

const ImageCutoutEditPerviewRender = ({
  oprationType,
  brushType,
  rebackable,
  canvasZoom,
  deleteOperateList,
  handlePrevBrush,
  handleNextBrush,
  handleCanvasMove,
  handleZoomCanvas,
  handleZoomCanvasPercent,
  handelRebackToUploadSuccessPage,
}) => {
  const { t } = useTranslation(["imageCutout", "common"]);

  return (
    <div className="work-cont-edit-perview">
      <RebackPageIcon className="goback-btn" onClick={handelRebackToUploadSuccessPage} />
      <div className={`image-cont ${oprationType === "brush" ? brushType : oprationType === "move" ? "move" : ""}`}>
        <canvas id="image-cutout-canvas" width={500} height={650}></canvas>
      </div>
      <Row className="opration-list" align="middle" gutter={[{ xs: 8, sm: 16 }, 0]}>
        <Tooltip placement="top" title={t("Move")}>
          <Col className={oprationType === "move" ? "active" : ""}>
            <ArrowIcon onClick={handleCanvasMove} />
          </Col>
        </Tooltip>
        <Tooltip placement="top" title={t("Undo")}>
          <Col>
            <RebackIcon onClick={handlePrevBrush} style={rebackable ? { color: "white" } : { color: "#5E5F62" }} />
          </Col>
        </Tooltip>
        <Tooltip placement="top" title={t("Redo")}>
          <Col>
            <ForwardIcon onClick={handleNextBrush} style={deleteOperateList.length ? { color: "white" } : { color: "#5E5F62" }} />
          </Col>
        </Tooltip>
        <Tooltip placement="top" title={t("Reduce")}>
          <Col>
            <ZoomOutIcon onClick={() => handleZoomCanvas(-0.5)} style={canvasZoom === 1 ? { color: "#5E5F62" } : { color: "white" }} />
          </Col>
        </Tooltip>
        <Tooltip placement="top" title={t("Enlarge")}>
          <Col>
            <ZoomInIcon onClick={() => handleZoomCanvas(0.5)} style={canvasZoom === 4 ? { color: "#5E5F62" } : { color: "white" }} />
          </Col>
        </Tooltip>
        <Col>
          <Select value={canvasZoom} onChange={handleZoomCanvasPercent} className="dark-select" dropdownClassName="dark-select-dropdown-new">
            <Option value={1}>100%</Option>
            <Option value={1.5}>150%</Option>
            <Option value={2}>200%</Option>
            <Option value={2.5} style={{ display: "none" }}>
              250%
            </Option>
            <Option value={3}>300%</Option>
            <Option value={3.5} style={{ display: "none" }}>
              350%
            </Option>
            <Option value={4}>400%</Option>
          </Select>
        </Col>
      </Row>
    </div>
  );
};

export default ImageCutoutEditPerviewRender;
